var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6475 2.93634C16.0379 2.54594 16.671 2.54616 17.0616 2.93634C17.4521 3.32682 17.4521 3.95986 17.0616 4.3504L12.0382 9.37384L17.0606 14.3963C17.4511 14.7869 17.4512 15.4209 17.0606 15.8113C16.6701 16.2018 16.037 16.2009 15.6466 15.8104L10.6251 10.7879L5.60359 15.8104C5.21311 16.2008 4.58005 16.2017 4.18953 15.8113C3.79928 15.4209 3.79928 14.7868 4.18953 14.3963L9.21102 9.37384L4.18856 4.3504C3.7982 3.95985 3.7981 3.32679 4.18856 2.93634C4.57907 2.54596 5.21214 2.54596 5.60262 2.93634L10.6251 7.9588L15.6475 2.93634Z",
    fill: "#ADADAD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.c832c907e8c6859b20e7c385b02ce082.svg";
export { ForwardRef as ReactComponent };